'use client';
import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 1001; //default z-index is 1000 for antd modal, drawer etc. The loader should have the biggest z-index.
  pointer-events: auto; //captures hover and clicks so the page behind cannot be used while loading.
  top: 0;
  left: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.8;

  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled.div`
  max-width: 380px;
  margin-bottom: 15px;
  text-align: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 224px;
  }
`;

const fadeUp = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const Text = styled.span`
  font-weight: bold;
  margin-top: 20px;
  color: ${({ theme }) => theme.palette.white};
  font-size: 24px;
  display: flex;
  justify-content: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }

  animation: ${fadeUp} 0.7s ease both;
`;

export const SubText = styled(Text)`
  font-size: 16px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }

  animation: ${fadeUp} 0.7s ease 0.25s both;
`;

export const Logo = styled.img`
  width: 150px;
  height: auto;
  display: block;
  user-select: none;
  pointer-events: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 120px;
  }
`;

export const LoadingText = styled(Text)`
  position: relative;
`;

export const LogoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  border-radius: 50%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 150px;
    height: 150px;
  }
`;

export const ProgressRing = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;

  .ring-track {
    fill: none;
    stroke: ${({ theme }) => theme.palette.whiteAlpha200};
    stroke-width: 4;
  }

  .ring-progress {
    fill: none;
    stroke: ${({ theme }) =>
      theme.palette.primaryBrand || theme.palette.orange};
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 528;
    stroke-dashoffset: 528;
    transform-origin: 50% 50%;
    animation: drawRing 3.2s ease-in-out infinite,
      rotateRing 2.4s linear infinite;
    filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.35));
  }

  @keyframes drawRing {
    0% {
      stroke-dashoffset: 528;
    }
    45% {
      stroke-dashoffset: 0;
    }
    60% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: 528;
    }
  }
  @keyframes rotateRing {
    to {
      transform: rotate(360deg);
    }
  }
`;
